module.exports = __webpack_public_path__ + "static/img/im.de2c825c.svg";